/* eslint-disable max-len */
import React, { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { deleteKey, getKey, setKey } from "app/shared/utils/EncryptionUtility";
import Constants, { Routes } from "app/shared/constants/constants";
import { isIOSDevice } from "app/shared/utils/utilityFunctions";

import useAppUtil from "./useAppUtil";

interface ContainerProps {
    children: ReactNode;
    isTStore?: boolean;
}

const PreventReload: React.FC<ContainerProps> = ({ children, isTStore = false }) => {
    const { resetApp } = useAppUtil();
    const location = useLocation();
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        const query = new URLSearchParams(location?.search);
        const selectedSite = query?.get('selectsite') || undefined;
        const pages = ["signup", "join", "forgotpassword", "giftcards", "giftcard", "myaccount", "myaccount/notifications", "unsubscribe", "rewards", "mobile/giftcard/transfer"];
        if (location.key === 'default' && selectedSite) {
            //initial deep link load
            deleteKey(Constants.REDIRECT_TO_HOME);
        }
        // Do not redirect to home page for the signup, forgot password, myaccount, giftcard transfer deep link
        if (pages.some((data) => window.location.href.includes(data))) {
            deleteKey(Constants.REDIRECT_TO_HOME);
        }

        if (window.location.href.indexOf("giftCards") > -1) {
            setKey(Constants.REDIRECT_TO_HOME, "1");
        }

        if (window.location.href.indexOf("passwordreset") > -1) {
            //For the reset password deep link, if the token is present do not redirect to home page
            const resetPasswordPath = query?.get('token') || undefined;
            if (resetPasswordPath) {
                deleteKey(Constants.REDIRECT_TO_HOME);
            } else {
                //if token is not available, redirect to home page: invalid link
                setKey(Constants.REDIRECT_TO_HOME, "1");
            }
        }
        if (!selectedSite) {
            if (getKey(Constants.REDIRECT_TO_HOME) === "1") {
                deleteKey(Constants.REDIRECT_TO_HOME);
                if (!isTStore) {
                    resetApp(Routes.CATEGORY, false);
                }
            }

            const confirmMessage = "Are you sure you want to leave this page? Your order will be lost.";

            const handleBeforeUnload = (event: BeforeUnloadEvent) => {
                setKey(Constants.REDIRECT_TO_HOME, "1");
                event.preventDefault();
                event.returnValue = confirmMessage;
            };
            const unloadEventName = isIOSDevice() ? "visibilitychange" : "beforeunload";
            if (!selectedSite) {
                window.addEventListener(unloadEventName, handleBeforeUnload);
            }
            return () => {
                if (!selectedSite) {
                    window.removeEventListener(unloadEventName, handleBeforeUnload);
                }
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return <div>{children}</div>;
};

export default PreventReload;
